package com.veldekar.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Iframe

@Composable
fun YouTubeVideo(url: String) {
    val videoId = when {
        url.contains("v=") -> url.substringAfter("v=").substringBefore("&")
        url.contains("youtu.be/") -> url.substringAfter("youtu.be/").substringBefore("?")
        else -> null
    }

    if (videoId != null) {
        Iframe(
            attrs = Modifier
                .fillMaxWidth()
                .aspectRatio(16, 9)
                .toAttrs {
                    attr("src", "https://www.youtube.com/embed/$videoId")
                    attr("frameborder", "0")
                    attr("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture")
                    attr("allowfullscreen", "")
                }
        )
    }
}
